export var AccessoryGroupRelationDirective = [
    'contentDictionary',
    function (contentDictionary) {
        return {
            link: function ($scope, $element) {
                var dictionaryKey = '';
                switch ($scope.relation) {
                    case 'Required':
                        dictionaryKey = 'AccessoriesRequired';
                        break;
                    case 'Recommended':
                        dictionaryKey = 'AccessoriesRecommended';
                        break;
                    default:
                        $element.remove();
                        break;
                }
                if (dictionaryKey !== '') {
                    contentDictionary.get(dictionaryKey).then(function (translation) {
                        $element.html(translation);
                    });
                }
            },
            scope: {
                relation: '@',
            },
        };
    },
];
